import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { S3BucketIntegrationRecord } from "../S3BucketIntegrationRecord";

import { getQueryKey } from "./useS3BucketIntegrations";

interface TestS3ConnectionParams {
  bucketName: string;
  orgId: string;
}

export function useTestS3Connection() {
  const { integrationService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<S3BucketIntegrationRecord, Error, TestS3ConnectionParams>({
    mutationFn: ({ bucketName, orgId }) =>
      integrationService.testS3BucketConnection(bucketName, orgId),
    onSuccess: (_record, { orgId }) => {
      // The check overwrote the bucket's status + summary server-side; refetch so the table reflects it.
      void queryClient.invalidateQueries({ queryKey: getQueryKey(orgId) });
    },
  });
}
